import { defineStore } from "pinia";
import { ref } from "vue";

export const useBreadcrumbStore = defineStore("breadcrumb", () => {
  const items = ref([]);
  const home = ref({ icon: "pi pi-home", to: "/" });

  const setItems = (newItems) => {
    items.value = Array.isArray(newItems) ? newItems : [];
  };

  const reset = () => {
    items.value = [];
  };

  return {
    items,
    home,
    setItems,
    reset,
  };
});
